import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import DataContext from '../../store/dataContext';
import UiContext from '../../store/uiContext';
import useErrors from '../../store/errors/useErrors';
import { setStatus } from '../../modules/billing/slice';

import './style.scss';

const Newsletter = () => {
  const { t } = useTranslation();
  const { resetErrorOnField } = useErrors();

  const { consent, updateConsent, setApiPostOrderError } = useContext(DataContext);
  const { checkoutStage, TO_USER_ADD } = useContext(UiContext);

  const dispatch = useDispatch();

  const isDisabled = checkoutStage === TO_USER_ADD;

  const handleCheck = check => {
    if (!check) {
      setApiPostOrderError({});
      resetErrorOnField('billingPhone');
      dispatch(setStatus({ isReady: true }));
    }
    updateConsent({
      hasSms: check,
    });
  };

  return (
    <label htmlFor="klaviyo-checkbox" className="klaviyo" style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}>
      <span className="warn">{t('newsletter.send_me_message')}</span>
      <input
        type="checkbox"
        checked={consent?.hasSms}
        onChange={evt => handleCheck(evt.target.checked)}
        id="klaviyo-checkbox"
      />
      <span className="checkmark" />
    </label>
  );
};

export default Newsletter;
